import { Component, ViewChild, ElementRef } from '@angular/core';
import { Toast } from 'bootstrap';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  standalone: false,
  //styleUrls: ['./toast.component.css']
})
export class ToastComponent {
  @ViewChild('toastElement', { static: true }) toastEl!: ElementRef;
  toastInstance!: Toast;

  message = '';
  type = 'success'; // success, danger, warning, info

  ngAfterViewInit() {
    this.toastInstance = new Toast(this.toastEl.nativeElement, { delay: 4000 });
  }

  show(message: string, type: 'success' | 'danger' | 'warning' | 'info' = 'success') {
    this.message = message;
    this.type = type;
    this.toastInstance.show();
  }
}
